/* tslint:disable:variable-name */

import { cloneDeep, uniqueId } from 'lodash';
import * as React from 'react';
import * as ReactRedux from 'react-redux';
import { Action, combineActions, createAction, createActions, handleAction, handleActions, Reducer } from 'redux-actions';
import { keyframes } from 'styled-components';
import { ActionDeclare, ApiDeclare, EffectDeclare, MenuDataInfo, ModelDeclare } from './interface';

const globalStore: string[] = ['global'];

export class ModelProxy<State = any, Payload = any> {
  private _namespace = uniqueId('@@init');
  private _route: MenuDataInfo = {
    name: this._namespace,
    path: this._namespace,
    component: () => (
      <span>init {this._namespace}, please set route in model</span>
    )
  };
  private _state: State;
  private _actions: ActionDeclare = {};
  private _effects: EffectDeclare = {};
  private _apis: ApiDeclare = {};
  private _reducer: Reducer<State, Payload>;

  constructor({
    namespace,
    route,
    state = {},
    actions = {},
    effects = {},
    apis = {}
  }: ModelDeclare) {
    this._namespace = namespace ? namespace : this._namespace;
    this._route = route ? route : this._route;
    this._state = state;

    const actionMap: any = {
      [`${namespace}/update_state`]: (statePayload: State, action: any) => ({
        ...statePayload, ...action.payload
      })
    };

    for (const k in actions) {
      if (actions.hasOwnProperty(k)) {
        const v = actions[k];
        actionMap[`${namespace}/${k}`] = v;
      }
    }

    this._actions = actionMap;
    this._effects = effects;
    this._apis = apis;

    this.createReducer();
    this.setConnect();
  }

  createReducer() {

    this._reducer = handleActions<State, Payload>(
      this._actions, this._state
    );
  }

  setConnect(
    mapStateToProps?: any,
    mapPropsToProps?: any,
    mergeProps?: any,
    options?: any
  ) {
    return (WrappedComp: React.ComponentClass) => {
      if (mapStateToProps) {
        return ReactRedux.connect(
          mapStateToProps,
          mapPropsToProps,
          mergeProps,
          options
        )(WrappedComp);
      }

      return ReactRedux.connect(
        (state: any, ownProps: any) => {
          const res: any = {};
          for (const name of globalStore) {
            res[name] = state[name];
          }

          res[this._namespace] = state[this._namespace];

          return res;
        },
        (dispatch: any, ...others: any[]) => {
          return {
            dispatch
          };
        }
      )(WrappedComp);
    };
  }

  applyMiddleware() {
    // set middleware
  }

  // getter
  get namespace(): string {
    return this._namespace;
  }

  get connect(): (
    mapStateToProps?: any,
    mapPropsToProps?: any,
    mergeProps?: any,
    options?: any
  ) => (WrappedComp: React.ComponentClass) => any {
    return this.setConnect;
  }

  get route(): MenuDataInfo {
    return this._route;
  }

  get state(): State {
    return this._state;
  }

  get actions(): ActionDeclare {
    return this._actions;
  }

  get effects(): EffectDeclare {
    return this._effects;
  }

  get apis(): ApiDeclare {
    return this._apis;
  }

  get reducer(): Reducer<State, Payload> {
    return this._reducer;
  }
}
